module.exports = "/fonts/Flaticon.svg?c1729513a8741b7b61bae040816e426f";